import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import { toast } from "react-toastify";
import FetchDNI from "./externalAPIs/FetchDNI";

const HandleUpdateDNI = async ({field, newValue, updateField, targetID, route, debounceUpdate, setElements = null, userCountry, setElement = null, element = null}) => {
  
  if (setElements) {
    setElements((prev) =>
      prev.map((e) =>
        e.id === targetID ? { ...e, [field]: newValue } : e
      )
    );
  }

  if (setElement && element) {
    setElement({ ...element, [field]: newValue });
  }

  if (field !== "dni" || (newValue?.length !== 8 && userCountry === "Perú")) {
    return
  }

  const userName = await FetchDNI({
    dni: newValue,
  });

  if (!userName && userCountry === "Perú") {
    toast.error("El DNI no existe");
    return;
  }

  if (setElements && userName) {
    setElements((prev) =>
      prev.map((e) =>
        e.id === targetID ? { ...e, [updateField]: userName} : e
      )
    );
  }

  if (setElement && element && userName) {
    setElement({ ...element, [updateField]: userName, [field]: newValue });
  }

  // Configurar debounce para evitar múltiples peticiones
  if (debounceUpdate.current) {
    clearTimeout(debounceUpdate.current);
  }


  debounceUpdate.current = setTimeout(async () => {
    try {
      await axios.put(`${BACKEND}/api/${route}/${targetID}`, {
        [field]: newValue,
        [updateField]: userName
      });

      toast.success("DNI validado con éxito!");
    } catch (e) {
      toast.error("Error al actualizar el dato: " + e.message);
    }
  }, 2000);
};

export default HandleUpdateDNI;
